import React from 'react';
import Spacer from './Spacer';
import { TriangleIconRight } from '../Iconset';

/**
 * provides the visual component of a collapsible element
 *
 * use in conjunction with other components to complete the collapsible functionality
 * @export
 * @param {{
 * [className=""]: String,
 * [state="none"]: String,
 * isExpanded: Boolean,
 * onToggleCallback?: (newState: Boolean)
 * }} props the following props may be used:
 * - className: an additional CSS class name to add to the collapsible component
 * - state: used for additional CSS formatting. *either "selected" or "none"*
 * - isExpanded: the current expansion state of the component
 * - onToggleCallback: a callback function that gets executed when the user interacts with the collapsible component, with the inversion of isExpanded as the passed parameter. *note: without this function, this component is meaningless*
 * @returns
 */
export default function CollapseToggle(props)
{
	const { iconOverride: IconOverride, ...restProps } = props;
	const IconComponent = IconOverride ? IconOverride : TriangleIconRight;

	return (
		<div
			className={props.className ? [
				"toggleCollapsibleElement",
				props.className,
			].join(' ') : "toggleCollapsibleElement"}
			data-status={props.state ? props.state : "none"}
			data-name={props["data-name"]}
			onClick={(e) =>
			{
				e.stopPropagation();

				if (props.onToggleCallback)
					props.onToggleCallback(!props.isExpanded, e.altKey);
			}}
		>
			<IconComponent data-name={props["data-name"]}
				fillStyle={props.fillStyle}
				scale={props.smallSized ? 0.7 : 1}
				rotate={props.isExpanded ? 90 : 0}
			/>
			<Spacer size={{ x: "6px" }} />
		</div>
	);
}